<template>
  <div class="GeneralCargoPerformance">
    <el-form
      class="custom-formScreen"
      :model="formScreen"
      ref="formScreen"
      inline
      label-width="4.8vw"
    >
      <div>
        <el-form-item prop="branchCompanyId" label="选择分公司" v-if="[1].includes(UserInfo.type)">
          <el-select
            filterable
            v-model="formScreen.branchCompanyId"
            value-key="company_id"
            @change="selectChange($event, 'listSonCompany')"
            :disabled="Boolean(formScreen.uid)"
          >
            <el-option
              v-for="item in listBranchCompany"
              :key="item.company_id"
              :label="item.companyName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sonCompanyId" label="选择子公司" v-if="[2, 1].includes(UserInfo.type)">
          <el-select
            filterable
            v-model="formScreen.sonCompanyId"
            value-key="rid"
            @change="selectChange($event, 'listDepartment')"
            :disabled="Boolean(formScreen.uid)"
          >
            <el-option
              v-for="item in listSonCompany"
              :key="item.company_id"
              :label="item.companyName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择平台" prop="sellerType">
          <el-select
            v-model="formScreen.sellerType"
            placeholder="请选择"
            @change="shopChange8"
            clearable
            :disabled="Boolean(formScreen.uid)"
          >
            <el-option
              v-for="item in platform"
              :key="item.sellerType"
              :label="item.itemTypeName"
              :value="item.sellerType"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="departmentVal"
          label="选择分部门"
          v-if="UserInfo.system < 3 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
        >
          <el-select
            v-model="formScreen.departmentVal"
            value-key="rid"
            @change="selectChange($event, 'listGroup')"
            :disabled="Boolean(formScreen.uid)"
          >
            <el-option
              v-for="item in listDepartment"
              :key="item.rid"
              :label="item.departmentName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="groupVal"
          label="选择组"
          v-if="UserInfo.system < 4 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
        >
          <el-select
            v-model="formScreen.groupVal"
            value-key="rid"
            @change="selectChange($event, 'listStaff')"
            :disabled="Boolean(formScreen.uid)"
          >
            <el-option
              v-for="item in listGroup"
              :key="item.rid"
              :label="item.groupName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="staffVal"
          label="选择员工"
          v-if="UserInfo.system < 5 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
        >
          <el-select
            v-model="formScreen.staffVal"
            value-key="rid"
            @change="selectChange($event, 'none')"
            :disabled="Boolean(formScreen.uid)"
          >
            <el-option
              v-for="item in listStaff"
              :key="item.rid"
              :label="item.roleUserName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sid" label="选择店铺">
          <el-select v-model="formScreen.sid" :disabled="isShopDisabled || Boolean(formScreen.uid)">
            <el-option
              v-for="item in listShop"
              :key="item.id"
              :label="item.shop_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="选择用户" prop="uid">
          <el-select
            v-model="formScreen.uid"
            placeholder="请选择"
            @change="shopChange9"
            clearable
            :disabled="Boolean(formScreen.sellerType)"
          >
            <el-option
              v-for="item in userList"
              :key="item.uid"
              :label="item.userName"
              :value="item.uid"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="时间范围" prop="fanweiTime" class="fanweiTime">
        <el-date-picker
          v-model="formScreen.fanweiTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
          :clearable="false"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="pickerOptions"
          popper-class="yejiduli">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="searchVal" label=" " style="width: 40%">
        <el-input
          placeholder="请输入订单号/订单ID"
          v-model="formScreen.searchVal"
          style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="searchForm" :loading="searchBtnLoading">搜索</el-button>
        <el-button type="primary" @click="resetForm" :loading="searchBtnLoading">重置</el-button>
      </el-form-item>
    </el-form>

    <p style="color: red;font-size: 16px;margin-top:-10px;margin-bottom: 10px;">
      <strong>注：该时区为美东-4时区时间。</strong>
    </p>
    <el-table border :data="listTableFirst" size="mini" v-loading="loadingTableFirst">
      <el-table-column prop="quantityOfOrder" label="订单量" align="center"></el-table-column>
      <el-table-column prop="issueQuantity" label="发出数量" align="center"></el-table-column>
      <el-table-column prop="adSpendAmount" label="广告花费金额($)" align="center"></el-table-column>
      <el-table-column prop="rebateAmount" label="返点($)" align="center"></el-table-column>
      <el-table-column prop="salesAmount" label="销售额($)" align="center"></el-table-column>
      <el-table-column prop="salesAmountChinese" label="销售额(￥)" align="center"></el-table-column>
      <el-table-column prop="receivedAmount" label="到账金额($)" align="center"></el-table-column>
      <el-table-column prop="receivedAmountChinese" label="到账金额(￥)" align="center"></el-table-column>
      <el-table-column prop="unitPrice" label="客单价($)" align="center"></el-table-column>
      <el-table-column prop="cpr" label="CPR($)" align="center"></el-table-column>
      <el-table-column prop="roi" label="ROI($)" align="center"></el-table-column>
      <el-table-column prop="logisticsCost" label="物流费(￥)" align="center"></el-table-column>
      <el-table-column prop="purchaseCost" label="采购费用(￥)" align="center"></el-table-column>
      <el-table-column prop="sharedFee" label="公摊费(￥)" align="center"></el-table-column>
      <el-table-column prop="handlingFee" label="手续费(￥)" align="center"></el-table-column>
      <el-table-column prop="platformCost" label="平台费(￥)" align="center"></el-table-column>
      <el-table-column prop="afterSalesFee" label="平台售后(￥)" align="center"></el-table-column>
      <el-table-column prop="platformFee" label="平台手续费(￥)" align="center"></el-table-column>
      <el-table-column align="center">
        <template slot="header">
          库存匹配费用
          <!-- <el-popover trigger="hover" placement="top">
          <p>收件费用、退件费用、分装费用、合装费用、包材费用、仓储费用、提现费用</p>
          <i class="iconfont icon-tishi" slot="reference"></i>
          </el-popover> -->
        </template>
        <template slot-scope="scope">
          <span>{{scope.row.warehouseCost}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="monthlyRentAmount" label="月租(￥)" align="center"></el-table-column> -->
      <el-table-column prop="paypalRefund" label="paypal退款(￥)" align="center"></el-table-column>
      <el-table-column prop="paypalDispute" label="paypal争议(￥)" align="center"></el-table-column>
      <el-table-column prop="paypalDisputeHandlingFee" label="paypal争议手续费(￥)" align="center"></el-table-column>
      <el-table-column prop="creditCardRefund" label="信用卡退款(￥)" align="center"></el-table-column>
      <el-table-column prop="creditCardChargeback" label="信用卡拒付(￥)" align="center"></el-table-column>
      <el-table-column prop="creditCardChargebackHandlingFee" label="信用卡拒付手续费(￥)" align="center"></el-table-column>
      <el-table-column prop="averageProfitPerOrder" label="每单平均利润(￥)" align="center"></el-table-column>
      <el-table-column prop="profitPercentage" label="利润百分比" align="center"></el-table-column>
      <el-table-column prop="profit" label="盈利(￥)" align="center"></el-table-column>
    </el-table>
    <el-divider></el-divider>
    <el-radio-group v-model="pageShow" size="small" @change="radioChange">
      <el-radio-button label="dateShow">按日期显示</el-radio-button>
      <el-radio-button label="orderShow">按订单显示</el-radio-button>
    </el-radio-group>
    <div class="leftSet">
      <span class="formula">公摊费=单量*{{shared}}元</span>
      <span class="formula">手续费=营业额*{{formalities}}%</span>
      <el-button type="primary" @click="dialogSetVisible=true" v-if="UserInfo.type == 3 && (UserInfo.system == 1 || UserInfo.superDepartmentName=='财务部')">设置</el-button>
      <el-popover
        placement="left"
        trigger="click"
        style="float: right; margin-left: 20px;"
        v-show="pageShow=='dateShow'">
        <div>
          <el-date-picker
            v-model="daochudata"
            type="datetimerange"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
          <el-button type="primary" @click="daochusubmit" style="float: right; margin-left: 10px;">
            确定
          </el-button>
        </div>
        <el-button type="primary" slot="reference" @click="dialogSetVisible1=true" v-if="UserInfo.type == 3 && (UserInfo.system == 1 || UserInfo.superDepartmentName=='财务部')">
          导出
        </el-button>
      </el-popover>
    </div>
    <!-- 按日期显示 -->
    <template v-if="pageShow === 'dateShow'">
      <el-table key="third" :data="listTableThird" border size="mini" v-loading="loadingTableThird" max-height="460">
        <el-table-column prop="time" fixed label="日期" align="center" width="90px"></el-table-column>
        <el-table-column prop="quantityOfOrder" label="订单量" align="center"></el-table-column>
        <el-table-column prop="issueQuantity" label="发出数量" align="center"></el-table-column>
        <el-table-column prop="adSpendAmount" label="广告花费金额($)" align="center"></el-table-column>
        <el-table-column prop="rebateAmount" label="返点($)" align="center"></el-table-column>
        <el-table-column prop="salesAmount" label="销售额($)" align="center"></el-table-column>
        <el-table-column prop="salesAmountChinese" label="销售额(￥)" align="center"></el-table-column>
         <el-table-column prop="receivedAmount" label="到账金额($)" align="center"></el-table-column>
        <el-table-column prop="receivedAmountChinese" label="到账金额(￥)" align="center"></el-table-column>
        <el-table-column prop="unitPrice" label="客单价($)" align="center"></el-table-column>
        <el-table-column prop="cpr" label="CPR($)" align="center"></el-table-column>
        <el-table-column prop="roi" label="ROI($)" align="center"></el-table-column>
        <el-table-column prop="logisticsCost" label="物流费(￥)" align="center"></el-table-column>
        <el-table-column prop="purchaseCost" label="采购费用(￥)" align="center"></el-table-column>
        <el-table-column prop="sharedFee" label="公摊费(￥)" align="center"></el-table-column>
        <el-table-column prop="handlingFee" label="手续费(￥)" align="center"></el-table-column>
        <el-table-column prop="platformCost" label="平台费(￥)" align="center"></el-table-column>
        <el-table-column prop="afterSalesFee" label="平台售后(￥)" align="center"></el-table-column>
        <el-table-column prop="platformFee" label="平台手续费(￥)" align="center"></el-table-column>
        <el-table-column align="center">
          <template slot="header">
            库存匹配费用
            <!-- <el-popover trigger="hover" placement="top">
            <p>收件费用、退件费用、分装费用、合装费用、包材费用、仓储费用、提现费用</p>
            <i class="iconfont icon-tishi" slot="reference"></i>
            </el-popover> -->
          </template>
          <template slot-scope="scope">
            <span>{{scope.row.warehouseCost}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="monthlyRentAmount" label="月租(￥)" align="center"></el-table-column> -->
        <el-table-column prop="paypalRefund" label="paypal退款(￥)" align="center"></el-table-column>
        <el-table-column prop="paypalDispute" label="paypal争议(￥)" align="center"></el-table-column>
        <el-table-column prop="paypalDisputeHandlingFee" label="paypal争议手续费(￥)" align="center"></el-table-column>
        <el-table-column prop="creditCardRefund" label="信用卡退款(￥)" align="center"></el-table-column>
        <el-table-column prop="creditCardChargeback" label="信用卡拒付(￥)" align="center"></el-table-column>
        <el-table-column prop="creditCardChargebackHandlingFee" label="信用卡拒付手续费(￥)" align="center"></el-table-column>
        <el-table-column prop="averageProfitPerOrder" label="每单平均利润(￥)" align="center"></el-table-column>
        <el-table-column prop="profitPercentage" label="利润百分比" align="center"></el-table-column>
        <el-table-column prop="profit" label="盈利(￥)" align="center"></el-table-column>
      </el-table>
      <el-row type="flex" justify="center" align="middle" class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="page1"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="size1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1"
        ></el-pagination>
      </el-row>
      <div class="echart" id="dateLine" style="width: 80%; height: 650px; margin-left: auto; margin-right: auto; margin-top: 25px;"></div>
    </template>
    <!-- 按订单显示 -->
    <template v-else-if="pageShow === 'orderShow'">
      <el-table key="second" :data="listTableSecond" size="mini" v-loading="loadingTableSecond" border max-height="460">
        <el-table-column prop="purchaseDate" label="日期" width="88" align="center"></el-table-column>
        <el-table-column prop="orderId" label="订单ID" fixed width="120" align="center"></el-table-column>
        <el-table-column width="200" label="系统SKU:SKU别名" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="top"
              trigger="click">
              <div v-if="scope.row.orderItems && scope.row.orderItems.length">
                <div v-for="(item, index) in scope.row.orderItems" :key="index+'a'">
                  <p style="margin-bottom: 5px;text-align: left;"><strong>系统SKU：</strong>{{ item.variantSku || '-' }}</p>
                  <p style="margin-bottom: 5px;text-align: left;"><strong>SKU别名：</strong>{{ item.sellerSKU || '-' }}</p>
                </div>
              </div>
              <el-button type="primary" size="small" slot="reference">查看SKU</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="adSpendAmount" label="平均广告花费金额($)" width="80" align="center"></el-table-column>
        <el-table-column prop="salesAmount" label="销售额($)" align="center"></el-table-column>
        <el-table-column prop="salesAmountChinese" label="销售额(￥)" align="center"></el-table-column>
        <el-table-column prop="receivedAmount" label="到账金额($)" align="center"></el-table-column>
        <el-table-column prop="receivedAmountChinese" label="到账金额(￥)" align="center"></el-table-column>
        <el-table-column prop="cpr" label="CPR($)" align="center"></el-table-column>
        <el-table-column prop="roi" label="ROI" align="center"></el-table-column>
        <el-table-column prop="logisticsCost" label="物流费(￥)" align="center"></el-table-column>
        <el-table-column prop="purchaseCost" label="采购费用(￥)" align="center"></el-table-column>
        <el-table-column prop="sharedFee" label="公摊费(￥)" align="center"></el-table-column>
        <el-table-column prop="handlingFee" label="手续费(￥)" align="center"></el-table-column>
        <el-table-column prop="platformCost" label="平台费(￥)" align="center"></el-table-column>
        <el-table-column prop="afterSalesFee" label="平台售后(￥)" align="center"></el-table-column>
        <el-table-column prop="platformFee" label="平台手续费(￥)" align="center"></el-table-column>
        <el-table-column align="center">
          <template slot="header">
            库存匹配费用
            <!-- <el-popover trigger="hover" placement="top">
            <p>收件费用、退件费用、分装费用、合装费用、包材费用、仓储费用、提现费用</p>
            <i class="iconfont icon-tishi" slot="reference"></i>
            </el-popover> -->
          </template>
          <template slot-scope="scope">
            <span>{{scope.row.warehouseCost}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="monthlyRentAmount" label="月租(￥)" align="center"></el-table-column> -->
        <el-table-column prop="paypalRefund" label="paypal退款(￥)" align="center"></el-table-column>
        <el-table-column prop="paypalDispute" label="paypal争议(￥)" align="center"></el-table-column>
        <el-table-column prop="paypalDisputeHandlingFee" label="paypal争议手续费(￥)" align="center"></el-table-column>
        <el-table-column prop="creditCardRefund" label="信用卡退款(￥)" align="center"></el-table-column>
        <el-table-column prop="creditCardChargeback" label="信用卡拒付(￥)" align="center"></el-table-column>
        <el-table-column prop="creditCardChargebackHandlingFee" label="信用卡拒付手续费(￥)" align="center"></el-table-column>
        <el-table-column prop="profit" label="盈利(￥)" align="center"></el-table-column>
        <el-table-column prop="profitPercentage" label="利润百分比" align="center"></el-table-column>
        <el-table-column prop="shopName" label="店铺" align="center" width="180"></el-table-column>
        <!-- <el-table-column prop="people" label="人员" align="center"></el-table-column> -->
        <el-table-column prop="amazonOrderId" label="订单号" align="center" width="160"></el-table-column>
      </el-table>
      <el-row type="flex" justify="center" align="middle" class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 2000]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-row>
    </template>

    <el-dialog title="修改提现费用比例" width="30%" :visible.sync="dialogVisible">
      <el-form label-width="80px">
        <el-form-item label="提现比例">
          <el-input v-model="withdrawalRatio2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="updateWithdrawalRatio"
          :loading="loadingStatus === 'dialogVisible'"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="设置" width="30%" :visible.sync="dialogSetVisible">
      <div style="margin-bottom: 15px">
        公摊费=单量*
        <el-input-number v-model="shared1" size="mini" :min="0" :controls="true" controls-position="both">
        </el-input-number>
        元
      </div>
      <div>
        手续费=营业额*
        <el-input-number v-model="formalities1" size="mini" :min="0" :controls="true" controls-position="both">
        </el-input-number>
        %
      </div>
      <div slot="footer">
        <el-button @click="dialogSetVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitShared"
          :loading="loadingShared"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api';
import * as echarts from 'echarts';
export default {
  name: "GeneralCargoPerformance",
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick: (picker) => {
            const date = new Date()
            picker.$emit('pick', date);
            this.calculationDate()
          }
        }, {
          text: '上一月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-1)
          }
        }, {
          text: '上两月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-2)
          }
        }, {
          text: '上三月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-3)
          }
        }]
      },
      UserInfo: {},
      companyId: '',
      rid: '',
      system: '',
      formScreen: {
        branchCompanyId: '',
        fanweiTime: [],
        sonCompanyId: '',
        departmentVal: '',
        groupVal: '',
        staffVal: '',
        sid: '',
        startTime: '',
        endTime: '',
        searchVal: '',
        sellerType: '',
        uid: ''
      },
      page: 1,
      size: 10,
      total: 0,
      listTableFirst: [],
      listTableSecond: [],

      listBranchCompany: [],
      listSonCompany: [],
      listDepartment: [],
      listGroup: [],
      listStaff: [],
      listShop: [],

      loadingTableFirst: false,
      loadingTableSecond: false,
      dialogVisible: false,
      withdrawalRatio: '',
      withdrawalRatio2: '',
      loadingStatus: '',
      pageShow: 'dateShow',
      listTableThird: [],
      loadingTableThird: true,
      page1: 1,
      size1: 10,
      total1: 0,
      platform: [],
      searchBtnLoading: false,
      dialogSetVisible: false,
      dialogSetVisible1: false,
      shared: '',
      formalities: '',
      shared1: '',
      formalities1: '',
      loadingShared: false,
      userList: [],
      daochudata: []
    };
  },
  computed: {
    isShopDisabled() {
      if (this.UserInfo.system === 5 && this.UserInfo.superDepartmentName.includes('运营部')) {
        return false
      } else {
        return !this.formScreen.staffVal
      }
    },
    screenObj() {
      return {
        companyId: this.companyId,
        rid: this.rid,
        system: this.system,
        sid: this.formScreen.sid,
      }
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem('role'))
    this.companyId = this.UserInfo.company_id
    this.rid = this.UserInfo.rid
    this.system = this.UserInfo.system

    this.init()
    this.getThisMonth()
    this.getListShop()
    this.getTableFirst()
    this.radioChange(this.pageShow)
    this.getFeeSetting()
    this.getUserList()
    if(this.UserInfo.type===3){
			this.getPlatform();
		}
  },
  watch: {
    dialogSetVisible() {
      this.shared1 = this.shared
      this.formalities1 = this.formalities
    }
  },
  methods: {
    init() {
      const { rid, system, company_id: companyId, type } = this.UserInfo;
      let listType = "";
      this.withdrawalRatio = this.UserInfo.company.withdrawalRatio
      if (type === 1) {
        listType = "listBranchCompany";
      } else if (type === 2) {
        listType = "listSonCompany";
      } else {
        listType = "listDepartment";
      }
      if (type === 3) {
        if (system === 3) {
          listType = "listGroup";
        } else if (system === 4) {
          listType = "listStaff";
        }
      }
      this.getNextPower(rid, system, companyId, listType);
    },
    daochusubmit() {
      if (!this.daochudata || !this.daochudata.length) {
        this.$message.error('请先选择时间范围！')
        return
      }
      window.open(`${Baseurl}/orderController/standAloneStationPerformanceExport?start=${this.daochudata[0]}&end=${this.daochudata[1]}&companyId=${this.companyId}`, 'target');
    },
    shopChange9() {
      this.formScreen.branchCompanyId = ''
      this.formScreen.sonCompanyId = ''
      this.formScreen.sellerType = ''
      this.formScreen.departmentVal = ''
      this.formScreen.groupVal = ''
      this.formScreen.staffVal = ''
      this.formScreen.sid = ''
    },
    getUserList() {
      if (this.system == 1) {
        const API = Baseurl + "userControllers/selectUserListByCompanyId"
        ajaxPost(API, { companyId: this.companyId }).then(res => {
          const {
            data: { code, data },
          } = res;
          if (code === 200) {
            this.userList = data
          }
        });
      } else {
        this.userList = [{uid: this.UserInfo.uid, userName: this.UserInfo.userName}]
      }
    },
    getFeeSetting() {
      const API = Baseurl + "dlzFeeSettingController/selectDlzFeeSetting"
      ajaxPost(API, { companyId: this.companyId }).then(res => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          if (!data) {
            this.loadingShared = false
            this.dialogSetVisible = false
            this.getTableThird()
          } else {
            this.shared = data.sharedFeePer
            this.formalities = data.feeRatio
            this.loadingShared = false
            this.dialogSetVisible = false
            this.getTableThird()
          }
        }
      });
    },
    submitShared() {
      console.log(this.shared, this.formalities);
      if (this.shared === undefined) {
        this.$message.error("公摊费单价必填")
        return
      }
      if (this.formalities === undefined) {
        this.$message.error("手续费百分比必填")
        return
      }
      this.loadingShared = true
      const API = Baseurl + "dlzFeeSettingController/setDlzFeeSetting"
      const data = {
        sharedFeePer: this.shared1,
        feeRatio: this.formalities1,
        companyId: this.companyId
      }
      ajaxPost(API, data).then(res => {
        const {
          data: { code },
        } = res;
        if (code === 200) {
          this.$message.success('设置成功')
          this.shared = this.shared1
          this.formalities = this.formalities1
          this.getFeeSetting()
        }
      });
    },
    shopChange8() {
      this.formScreen.uid = ''
      if(this.UserInfo.type !== 3){
        this.rid = this.formScreen.sonCompanyId.rid;
        this.system = this.UserInfo.system;
      } else {
        this.rid = this.UserInfo.rid;
        this.system = this.UserInfo.system;
      }
      this.getNextPower(this.rid, this.system, this.companyId, 'listDepartment');
      this.formScreen.departmentVal = '';
      this.formScreen.groupVal = '';
      this.formScreen.staffVal = '';
      this.listStaff = [];
      this.formScreen.sid = '';
      this.listShop = []
      this.listGroup = [];
    },
    getPlatform() {
      this.platform = [
        {sellerType: 2, itemTypeName: "Shopify"},
        {sellerType: 5, itemTypeName: "Shoplazza"},
        {sellerType: 7, itemTypeName: "Shopline"}
      ]
    },
    getNextPower(rid, system, companyId, type) {
      const API = Baseurl + "roleController/selectNextAndSellerInfoByRid";
      let paramsData = { rid, system, companyId, sellerType: this.formScreen.sellerType };

      ajaxPost(API, paramsData).then(res => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this[type] = data.next;
        }
      });
    },
    selectChange(event, type) {
      const { rid, system, company_id: companyId } = event;
      companyId && (this.companyId = companyId);
      rid && (this.rid = rid);
      system && (this.system = system);
      if (!system) this.system = this.UserInfo.system;
      if (!companyId) this.companyId = this.UserInfo.company_id;
      if (!rid) this.rid = this.UserInfo.rid;

      this.listShop = []
      this.formScreen.sid = ''
      if (type === "none") {
        this.getListShop()
        return;
      }
      this.getNextPower(rid, system, companyId, type);

      if (type == "listDepartment") {
        this.getPlatform();
      }

      this.formScreen.staffVal = {};
      this.listStaff = [];
      if (type === "listStaff") return;
      this.formScreen.groupVal = {};
      this.listGroup = [];
      if (type === "listGroup") return;
      this.formScreen.departmentVal = {};
      this.listDepartment = [];
      this.formScreen.sellerType = '';
      this.platform = [];
      if (type === "listDepartment") return;
      this.formScreen.sonCompanyId = {};
      this.listSonCompany = [];
    },
    getThisMonth() {
      const nowDate = new Date()
      const nowTimeStamp = nowDate.getTime()
      const nowYear = nowDate.getFullYear()
      const nowMonth = nowDate.getMonth() + 1
      const nowDay = nowDate.getDate()

      const startTimeStamp = nowTimeStamp - (3600 * 1000 * 24 * 30)
      const startDate = new Date(startTimeStamp)
      const startYear = startDate.getFullYear()
      const startMonth = startDate.getMonth() + 1
      const startDay = startDate.getDate()

      this.formScreen.startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`
      this.formScreen.endTime = `${nowYear}-${nowMonth}-${nowDay} 23:59:59`
      this.formScreen.fanweiTime = [this.formScreen.startTime, this.formScreen.endTime]
    },
    radioChange(event) {
      if (event === 'orderShow') {
        this.getTableScond()
      } else if (event === 'dateShow') {
        this.getFeeSetting()
      }
    },
    getTableFirst() {
      const API = Baseurl + 'orderPerformanceController/getStandAloneStationOrderTotalPerformanceByRoleIdNew'
      const paramsData = {
        startTime: this.formScreen.fanweiTime.length ? this.formScreen.fanweiTime[0] : '',
        endTime: this.formScreen.fanweiTime.length ? this.formScreen.fanweiTime[1] : '',
        searchVal: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        uid: this.formScreen.uid,
        ...this.screenObj
      }
      this.loadingTableFirst = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTableFirst = false
        if (code === 200) {
          this.listTableFirst = [data]
        } else {
          this.$message.error(data)
        }
      })
    },
    getTableScond() {
      const API = Baseurl + 'orderPerformanceController/getStandAloneStationStorePerformanceStatisticsNew'
      const paramsData = {
        page: this.page,
        size: this.size,
        startTime: this.formScreen.fanweiTime.length ? this.formScreen.fanweiTime[0] : '',
        endTime: this.formScreen.fanweiTime.length ? this.formScreen.fanweiTime[1] : '',
        searchVal: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        uid: this.formScreen.uid,
        ...this.screenObj
      }
      this.loadingTableSecond = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTableSecond = false
        this.searchBtnLoading = false
        if (code === 200) {
          this.listTableSecond = data.list
          this.total = data.total
        }
      })
    },
    getTableThird() {
      const API = Baseurl + 'orderPerformanceController/selectStandAloneStationStorePerformanceStatisticsNew'
      const paramsData = {
        page: this.page1,
        size: this.size1,
        startTime: this.formScreen.fanweiTime.length ? this.formScreen.fanweiTime[0] : '',
        endTime: this.formScreen.fanweiTime.length ? this.formScreen.fanweiTime[1] : '',
        searchVal: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        uid: this.formScreen.uid,
        ...this.screenObj
      }
      this.loadingTableThird = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTableThird = false
        this.searchBtnLoading = false
        if (code === 200) {
          // data.list.forEach(item => item.amountChina = item.money.amountChina)
          this.listTableThird = data.list
          this.total1 = data.total

          let timeData = []
          let quantityOfOrderData = []
          let issueQuantityData = []
          let adSpendAmountData = []
          let salesAmountData = []
          let salesAmountChineseData = []
          let unitPriceData = []
          let cprData = []
          let roiData = []
          let logisticsCostData = []
          let purchaseCostData = []
          let sharedFeeData = []
          let handlingFeeData = []
          let platformCostData = []
          let afterSalesFeeData = []
          let platformFeeData = []
          let warehouseCostData = []
          let paypalRefundData = []
          let paypalDisputeData = []
          let paypalDisputeHandlingFeeData = []
          let creditCardRefundData = []
          let creditCardChargebackData = []
          let creditCardChargebackHandlingFeeData = []
          let averageProfitPerOrderData = []
          let profitData = []

           const dateLine = echarts.init(document.getElementById('dateLine'))

          timeData = this.listTableThird.map(item => item.time)
          quantityOfOrderData = this.listTableThird.map(item => item.quantityOfOrder)
          issueQuantityData = this.listTableThird.map(item => item.issueQuantity)
          adSpendAmountData = this.listTableThird.map(item => item.adSpendAmount)
          salesAmountData = this.listTableThird.map(item => item.salesAmount)
          salesAmountChineseData = this.listTableThird.map(item => item.salesAmountChinese)
          unitPriceData = this.listTableThird.map(item => item.unitPrice)
          cprData = this.listTableThird.map(item => item.cpr)
          roiData = this.listTableThird.map(item => item.roi)
          logisticsCostData = this.listTableThird.map(item => item.logisticsCost)
          purchaseCostData = this.listTableThird.map(item => item.purchaseCost)
          sharedFeeData = this.listTableThird.map(item => item.sharedFee)
          handlingFeeData = this.listTableThird.map(item => item.handlingFee)
          platformCostData = this.listTableThird.map(item => item.platformCost)
          afterSalesFeeData = this.listTableThird.map(item => item.afterSalesFee)
          platformFeeData = this.listTableThird.map(item => item.platformFee)
          warehouseCostData = this.listTableThird.map(item => item.warehouseCost)
          paypalRefundData = this.listTableThird.map(item => item.paypalRefund)
          paypalDisputeData = this.listTableThird.map(item => item.paypalDispute)
          paypalDisputeHandlingFeeData = this.listTableThird.map(item => item.paypalDisputeHandlingFee)
          creditCardRefundData = this.listTableThird.map(item => item.creditCardRefund)
          creditCardChargebackData = this.listTableThird.map(item => item.creditCardChargeback)
          creditCardChargebackHandlingFeeData = this.listTableThird.map(item => item.creditCardChargebackHandlingFee)
          averageProfitPerOrderData = this.listTableThird.map(item => item.averageProfitPerOrder)
          profitData = this.listTableThird.map(item => item.profit)

          dateLine.setOption({
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '10%'];
              }
            },
            legend: {
              type: 'scroll',
              left: 'center',
              width: '80%',
              textStyle: {
                color: '#4c9bfd' // 图例文字颜色
              },
              selected: {
                '订单量': true,
                '发出数量': true,
                '广告花费金额($)': true,
                '销售额($)': true,
                '销售额(￥)': false,
                '客单价($)': true,
                'cpr': false,
                'roi': false,
                '物流费(￥)': false,
                '采购费用(￥)': false,
                '公摊费(￥)': false,
                '手续费(￥)': false,
                '平台费(￥)': false,
                '平台售后(￥)': false,
                '平台手续费(￥)': false,
                '库存匹配费用': false,
                'paypal退款(￥)': false,
                'paypal争议(￥)': false,
                'paypal争议手续费(￥)': false,
                '信用卡退款(￥)': false,
                '信用卡拒付(￥)': false,
                '信用卡拒付手续费(￥)': false,
                '每单平均利润(￥)': true,
                '盈利(￥)': true
              }
            },
            grid: {
              top: "20%",
              left: "3%",
              right: "4%",
              bottom: "3%",
              show: true, // 显示边框
              borderColor: "#012f4a", // 边框颜色
              containLabel: true // 包含刻度文字在内
            },
            title: {
              text: '日期统计数据'
            },
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: 'none'
                },
                restore: {},
                saveAsImage: {}
              }
            },
            xAxis: {
              boundaryGap: false,
              data: timeData,
              inverse: true
            },
            yAxis: {
              type: 'value',
              boundaryGap: [0, '40%'],
              axisLine: {
                show: false // 去除轴线
              },
              splitLine: {
                lineStyle: {
                  color: '#ddd' // 分割线颜色
                }
              }
            },
            series: [
              {
                name: '订单量',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: quantityOfOrderData
              },
              {
                name: '发出数量',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: issueQuantityData
              }, {
                name: '广告花费金额($)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: adSpendAmountData
              }, {
                name: '销售额($)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: salesAmountData
              }, {
                name: '销售额(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: salesAmountChineseData
              }, {
                name: '客单价($)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: unitPriceData
              }, {
                name: 'cpr',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: cprData
              }, {
                name: 'roi',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: roiData
              }, {
                name: '物流费(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: logisticsCostData
              }, {
                name: '采购费用(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: purchaseCostData
              }, {
                name: '公摊费(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: sharedFeeData
              }, {
                name: '手续费(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: handlingFeeData
              }, {
                name: '平台费(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: platformCostData
              }, {
                name: '平台售后(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: afterSalesFeeData
              }, {
                name: '平台手续费(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: platformFeeData
              }, {
                name: '库存匹配费用',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: warehouseCostData
              }, {
                name: 'paypal退款(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: paypalRefundData
              }, {
                name: 'paypal争议(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: paypalDisputeData
              }, {
                name: 'paypal争议手续费(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: paypalDisputeHandlingFeeData
              }, {
                name: '信用卡退款(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: creditCardRefundData
              }, {
                name: '信用卡拒付(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: creditCardChargebackData
              }, {
                name: '信用卡拒付手续费(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: creditCardChargebackHandlingFeeData
              }, {
                name: '每单平均利润(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: averageProfitPerOrderData
              }, {
                name: '盈利(￥)',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 8,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: profitData
              }
            ]
          })
        }
      })
    },
    getListShop() {
      const API = Baseurl + 'sellerController/selectMyShopByRid1'
      const paramsData = {
        rid: this.rid,
        system: this.system
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listShop = data
        }
      })
    },
    searchForm() {
      this.getTableFirst()
      this.searchBtnLoading = true
      if (this.pageShow === 'orderShow') {
        this.page = 1
        this.getTableScond()
      } else if (this.pageShow === 'dateShow') {
        this.page1 = 1
        this.getTableThird()
      }
    },
    resetForm() {
      this.page = 1
      this.$refs.formScreen.resetFields();
      this.listBranchCompany = [];
      this.listSonCompany = [];
      this.listDepartment = [];
      this.listGroup = [];
      this.listStaff = [];
      this.listShop = [];
      this.rid = this.UserInfo.rid
      this.system = this.UserInfo.system
      this.companyId = this.UserInfo.company_id

      this.init();
      this.getThisMonth()
      this.searchForm()
    },
    handleSizeChange(val) {
      this.size = val
      this.getTableScond()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getTableScond()
    },
    handleSizeChange1(val) {
      this.size1 = val
      this.getTableThird()
    },
    handleCurrentChange1(val) {
      this.page1 = val
      this.getTableThird()
    },
    calculationDate(type = 0) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = (month + type - 1 + 12) % 12 + 1;
      this.formScreen.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;
      const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
      this.formScreen.endTime = `${prevMonth} 23:59:59`
      this.formScreen.fanweiTime = [this.formScreen.startTime, this.formScreen.endTime]
    },
    openWithdrawalRatio() {
      const { type, system, superDepartmentName } = this.UserInfo
      if ((type === 3 && system === 1) || (type === 3 && superDepartmentName === '财务部')) {
        this.withdrawalRatio2 = this.withdrawalRatio
        this.dialogVisible = true
      }
    },
    updateWithdrawalRatio() {
      const API = Baseurl + 'companyController/updateCompanyWithdrawalRatio'
      const paramsData = {
        id: this.UserInfo.company_id,
        withdrawalRatio: this.withdrawalRatio2
      }
      this.loadingStatus = 'dialogVisible'
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingStatus = ''
        if (code === 200) {
          this.UserInfo.company = data
          localStorage.setItem('role', JSON.stringify(this.UserInfo))
          this.withdrawalRatio = this.UserInfo.company.withdrawalRatio
          this.$message.success('操作成功')
          this.searchForm()
          this.dialogVisible = false
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.GeneralCargoPerformance {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;
  margin-top: 20px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }

  .leftSet {
    float: right;
    .formula {
      margin-right: 20px;
      font-size: 14px;
      font-weight: bolder;
    }
  }
  .fanweiTime {
    width: 30%;
  }
}
</style>

<style>
.yejiduli .el-picker-panel__footer .el-button:first-child {
  display: none;
}
</style>
